export const INITIAL = 0;
export const FETCHING = 1;
export const FETCHED = 2;
export const FAILED = 3;


// WEBPACK FOOTER //
// ./src/constants/fetchingState.js